import Vue from "vue";
import store from "@/store/store";

import PresenceHeader from "@/documents/presence/header";
import PresenceFooter from "@/documents/presence/footer";
import PresenceContent from "@/documents/presence/content";

import PvHeader from "@/documents/pv/header";
import PvFooter from "@/documents/pv/footer";
import PvContent from "@/documents/pv/content";
import PvAntetContent from "@/documents/pv/components/antetContent";

import OrderHeader from "@/documents/order/header";
import OrderFooter from "@/documents/order/footer";
import OrderContent from "@/documents/order/content";

import InvitationHeader from "@/documents/invitation/header";
import InvitationFooter from "@/documents/invitation/footer";
import InvitationContent from "@/documents/invitation/content";
import InvitationAntetContent from "@/documents/invitation/antetConvocation";

import PouvoirHeader from "@/documents/pouvoir/header";
import PouvoirFooter from "@/documents/pouvoir/footer";
import PouvoirContent from "@/documents/pouvoir/content";

import VBCHeader from "@/documents/vbc/header";
import VBCFooter from "@/documents/vbc/footer";
import VBCContent from "@/documents/vbc/content";

import EmptyPdfHeader from "@/documents/empty/header";
import EmptyPdfFooter from "@/documents/empty/footer";
import EmptyPdfContent from "@/documents/empty/content";

import moment from "moment";

export default function () {
  function generateTemplatePresence(meeting, pdfFooterMessage, mediaSignatures) {
    return new Promise(resolve => {
      let templateHeader = generateTemplate(PresenceHeader, {
        meetingDate: formatDate(meeting.meeting_date),
        logoInBase64: meeting.logoInBase64,
        allowedModalities: meeting.allowed_modalities,
      });

      let templateFooter = generateTemplate(PresenceFooter, {
        logoInBase64: meeting.logoInBase64,
        pdfFooterMessage: pdfFooterMessage,
      });

      let templateContent = generateTemplate(PresenceContent, {
        meetingMinutes: meeting.minutes,
        presenceSignatures: mediaSignatures,
        resolutions: meeting.meeting_resolutions,
      });
      resolve({
        header: templateHeader,
        footer: templateFooter,
        content: templateContent,
      });
    });
  }
  function generateTemplatePv(meeting, pdfFooterMessage, generatePvOption) {
    return new Promise(resolve => {
      let templateHeader = generateTemplate(PvHeader, {
        meetingDate: formatDate(meeting.meeting_date),
        logoInBase64: meeting.logoInBase64,
      });

      let templateFooter = generateTemplate(PvFooter, {
        logoInBase64: meeting.logoInBase64,
        pdfFooterMessage: pdfFooterMessage,
      });

      let templateContent = generateTemplate(PvContent, {
        meeting: {
          id: meeting.id,
          date: formatDate(meeting.meeting_date),
          allowed_modalities: meeting.allowed_modalities,
          address: meeting.address,
          access: meeting.access,
          minutes: meeting.minutes,
        },
        resolutions: meeting.meeting_resolutions,
        generatePvOption: generatePvOption,
      });
      resolve({
        header: templateHeader,
        footer: templateFooter,
        content: templateContent,
      });
    });
  }
  function generateTemplatePvAntet(
    meeting,
    mandate,
    recipient,
    pdfFooterMessage,
    allCountries,
    pdfContactDetails
  ) {
    return new Promise(resolve => {
      let templateHeader = generateTemplate(PvHeader, {
        meetingDate: formatDate(meeting.meeting_date),
        logoInBase64: meeting.logoInBase64,
      });
      let templateFooter = generateTemplate(PvFooter, {
        logoInBase64: meeting.logoInBase64,
        pdfFooterMessage: pdfFooterMessage,
      });
      let templateContent = generateTemplate(PvAntetContent, {
        mandate,
        recipient,
        countries: allCountries,
        pdfContactDetails: pdfContactDetails,
      });
      resolve({
        header: templateHeader,
        footer: templateFooter,
        content: templateContent,
      });
    });
  }

  function generateTemplateOrder(meeting, pdfFooterMessage) {
    return new Promise(resolve => {
      let templateHeader = generateTemplate(OrderHeader, {
        meetingDate: formatDate(meeting.meeting_date),
        buildingName: meeting.building.name,
        logoInBase64: meeting.logoInBase64,
      });

      let templateFooter = generateTemplate(OrderFooter, {
        logoInBase64: meeting.logoInBase64,
        pdfFooterMessage: pdfFooterMessage,
      });

      let templateContent = generateTemplate(OrderContent, {
        meeting: {
          id: meeting.id,
          date: formatDate(meeting.meeting_date),
          allowed_modalities: meeting.allowed_modalities,
          address: meeting.address,
          access: meeting.access,
        },
        building: {
          name: meeting.building.name,
          address: meeting.building.address,
        },
        resolutions: meeting.meeting_resolutions,
      });
      resolve({
        header: templateHeader,
        footer: templateFooter,
        content: templateContent,
      });
    });
  }
  function generateTemplateInvitation(
    meeting,
    mandate,
    pdfFooterMessage,
    allCountries,
    pdfContactDetails,
    isForOneMandate,
    qrCodeBase64Image
  ) {
    return new Promise(resolve => {
      let templateHeader = generateTemplate(InvitationHeader, {
        meetingDate: formatDate(meeting.meeting_date),
        buildingName: meeting.building.name,
        logoInBase64: meeting.logoInBase64,
      });
      let templateFooter = generateTemplate(InvitationFooter, {
        logoInBase64: meeting.logoInBase64,
        pdfFooterMessage: pdfFooterMessage,
      });
      let templateContent = generateTemplate(InvitationContent, {
        meeting: {
          id: meeting.id,
          date: formatDate(meeting.meeting_date),
          allowed_modalities: meeting.allowed_modalities,
          address: meeting.address,
          access: meeting.access,
          external_video_solution: meeting.external_video_solution,
          show_connection_details: meeting.show_connection_details,
        },
        building: {
          name: meeting.building.name,
          address: meeting.building.address,
        },
        resolutions: meeting.meeting_resolutions,
        mandate: mandate,
        countries: allCountries,
        pdfContactDetails: pdfContactDetails,
        isForOneMandate: isForOneMandate,
        qrCodeBase64Image: qrCodeBase64Image,
      });
      resolve({
        header: templateHeader,
        footer: templateFooter,
        content: templateContent,
      });
    });
  }
  function generateTemplateInvitationAntet(
    meeting,
    mandate,
    pdfFooterMessage,
    allCountries,
    pdfContactDetails,
    recipient
  ) {
    return new Promise(resolve => {
      let templateHeader = generateTemplate(InvitationHeader, {
        meetingDate: formatDate(meeting.meeting_date),
        buildingName: meeting.building.name,
        logoInBase64: meeting.logoInBase64,
      });
      let templateFooter = generateTemplate(InvitationFooter, {
        logoInBase64: meeting.logoInBase64,
        pdfFooterMessage: pdfFooterMessage,
      });
      let templateContent = generateTemplate(InvitationAntetContent, {
        building: {
          name: meeting.building.name,
          address: meeting.building.address,
        },
        mandate: mandate,
        countries: allCountries,
        pdfContactDetails: pdfContactDetails,
        recipient,
      });
      resolve({
        header: templateHeader,
        footer: templateFooter,
        content: templateContent,
      });
    });
  }
  function generateTemplatePouvoir(meeting, mandate, pdfFooterMessage, qrCodeBase64Image) {
    return new Promise(resolve => {
      let templateHeader = generateTemplate(PouvoirHeader, {
        meetingDate: formatDate(meeting.meeting_date),
        buildingName: meeting.building.name,
        logoInBase64: meeting.logoInBase64,
      });
      let templateFooter = generateTemplate(PouvoirFooter, {
        logoInBase64: meeting.logoInBase64,
        pdfFooterMessage: pdfFooterMessage,
      });
      let templateContent = generateTemplate(PouvoirContent, {
        meeting: {
          id: meeting.id,
          date: formatDate(meeting.meeting_date),
          allowed_modalities: meeting.allowed_modalities,
          address: meeting.address,
          access: meeting.access,
        },
        building: {
          name: meeting.building.name,
          address: meeting.building.address,
          votes_per_mandate: meeting.building.votes_per_mandate,
          parts_per_mandate: meeting.building.parts_per_mandate,
        },
        mandate: {
          building_owner: mandate.building_owner,
        },
        qrCodeBase64Image: qrCodeBase64Image,
      });
      resolve({
        header: templateHeader,
        footer: templateFooter,
        content: templateContent,
      });
    });
  }
  function generateTemplateVBC(
    meeting,
    mandate,
    pdfFooterMessage,
    allCountries,
    majorities,
    pdfContactDetails,
    agencyEmail
  ) {
    return new Promise(resolve => {
      let templateHeader = generateTemplate(VBCHeader, {
        meetingDate: formatDate(meeting.meeting_date),
        buildingName: meeting.building.name,
        logoInBase64: meeting.logoInBase64,
      });
      let templateFooter = generateTemplate(VBCFooter, {
        logoInBase64: meeting.logoInBase64,
        pdfFooterMessage: pdfFooterMessage,
      });
      let templateContent = generateTemplate(VBCContent, {
        meeting: {
          id: meeting.id,
          date: formatDate(meeting.meeting_date),
          last_reception_date: meeting.last_reception_date,
          allowed_modalities: meeting.allowed_modalities,
          address: meeting.address,
          access: meeting.access,
          external_video_solution: meeting.external_video_solution,
          show_connection_details: meeting.show_connection_details,
        },
        building: {
          name: meeting.building.name,
          address: meeting.building.address,
        },
        resolutions: meeting.meeting_resolutions,
        mandate: {
          building_owner: mandate.building_owner,
        },
        countries: allCountries,
        majorities: majorities,
        pdfContactDetails: pdfContactDetails,
        agencyEmail: agencyEmail,
      });
      resolve({
        header: templateHeader,
        footer: templateFooter,
        content: templateContent,
      });
    });
  }

  function generateTemplateEmptyContent(logoInBase64, pdfContactDetails, pdfFooterMessage) {
    return new Promise(resolve => {
      let templateHeader = generateTemplate(EmptyPdfHeader, {
        logoInBase64: logoInBase64,
      });

      let templateFooter = generateTemplate(EmptyPdfFooter, {
        pdfFooterMessage: pdfFooterMessage,
        logoInBase64: logoInBase64,
      });

      let templateContent = generateTemplate(EmptyPdfContent, {
        pdfContactDetails: pdfContactDetails,
      });

      resolve({
        header: templateHeader,
        footer: templateFooter,
        content: templateContent,
      });
    });
  }

  /**
   *
   * @param {*} templateType
   * @param {*} props
   */
  function generateTemplate(templateType, props) {
    let Template = Vue.extend(templateType);
    let template = new Template({
      propsData: props,
      store, // NOTE: to be able to use this.$store from documents (for voting limit rules & meeting details info)
    });
    template.$mount();
    let html = template.$el.outerHTML;
    template.$destroy();
    return html;
  }

  /**
   * Creates an anchor element `<a></a>` with
   * the base64 pdf source and a filename with the
   * HTML5 `download` attribute then clicks on it.
   */
  function downloadDialog(doc, docName, docExtension) {
    const linkSource = `data:application/${docExtension};base64,${doc}`;
    const downloadLink = document.createElement("a");
    const fileName = docName + "." + docExtension;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  /**
   * Make sure format is utc and then displayed in local timezone
   * @param {*} meetingDate
   */
  function formatDate(meetingDate) {
    if (
      moment.parseZone(meetingDate).utcOffset() > 0 ||
      moment.parseZone(meetingDate).utcOffset() < 0
    ) {
      let utcFormatted = moment
        .parseZone(meetingDate)
        .utcOffset(0, true)
        .format("YYYY-MM-DDTHH:mm:ssZ");
      return moment(utcFormatted).format("YYYY-MM-DDTHH:mm:ssZ");
    } else {
      return moment(meetingDate).format("YYYY-MM-DDTHH:mm:ssZ");
    }
  }

  return {
    generateTemplatePresence,
    generateTemplatePv,
    generateTemplateOrder,
    generateTemplateInvitation,
    generateTemplatePouvoir,
    generateTemplateVBC,
    downloadDialog,
    generateTemplatePvAntet,
    generateTemplateInvitationAntet,
    generateTemplateEmptyContent,
  };
}
